import { btbTmcEn, btbTmcGe } from "../data/b2bTmcData";
import { useParams } from "react-router-dom";

export const TermsAndConditions = () => {
  const { lang } = useParams();

  return (
    <div className="flex flex-col">
      {lang === "ka" ? btbTmcGe[0]?.title : btbTmcEn[0]?.title}
      {lang === "ka" ? btbTmcGe[0]?.content : btbTmcEn[0]?.content}
    </div>
  );
};
